export const COORDS_MULTIPLIER = 10_000
